import React, { Component } from 'react';

import ComponentWrapper from '../../common/ComponentWrapper';
import { Table, TableBody, TableCell, TableRow } from '@mui/material';
import { withStyles } from '@mui/styles';
import CommonStyles from '../../common/CommonStyles';

import Requests from './Requests';

import moment from 'moment';

const notificationSound = new Audio('/audio/system_alert.mp3');

const styles = {
  ...CommonStyles,
  tbl: {
    margin: '20px 0 0 20px',
    width: '470px',
  },
  tCellTitle: {
    width: '280px',
    padding: '2px 10px 2px 10px',
    fontSize: '12px',
    fontWeight: 550,
    background: '#eeecf8',
  },
  tCell: {
    padding: '2px 2px 2px 10px',
    fontSize: '12px',
  },
  tRow: {
    '&:hover': {
      background: '#C9C4E4',
      '& $tCellTitle': {
        background: '#C9C4E4',
      },
    },
  },
};

class SystemIndicatorsWrapper extends ComponentWrapper {
  state = {
    pageTitleIntervalId: null,
    playSoundTimerId: null,
    server_urls: null,
    public_sec_key: '',
  };

  componentDidMount() {
    document.title = "System | Milkyweb";
    this.getMetaQuery();
    
    window.addEventListener('mousemove', this.handleMouseMove);
  };

  componentWillUnmount() {
    window.removeEventListener('mousemove', this.handleMouseMove);

    if (this.state.playSoundTimerId) {
      clearTimeout(this.state.playSoundTimerId);
    }
  };

  getMetaQuery = () => {
    this.get({
      url: '/meta_query?meta_query=["server_urls","public_sec_key"]',
      cb: (res) => {
        if (res) {
          const { server_urls, public_sec_key } = res._meta_query;

          this.setState({ server_urls, public_sec_key });
        }
      },
      disableNotify: true,
    });
  };

  handleMouseMove = () => {
    // Prevent sound from playing when mouse moves
    this.setState({ canPlaySound: false });

    // Clear the existing timer if it exists
    if (this.state.playSoundTimerId) {
      clearTimeout(this.state.playSoundTimerId);
    }

    // Set a new timer to re-enable sound after 5 seconds
    const playSoundTimerId = setTimeout(() => {
      this.setState({ canPlaySound: true });
    }, 5000);
    this.setState({ playSoundTimerId });
  };

  setEmojiFavicon = (emoji) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = 64; // Set the size of the canvas
    canvas.height = 64;
  
    // Set the font size and draw the emoji
    context.font = '60px serif';
    context.fillText(emoji, 0, 56);
  
    // Convert the canvas to a data URL
    const dataUrl = canvas.toDataURL('image/png');
  
    // Set the favicon
    const link = document.querySelector("link[rel~='icon']");
    if (!link) {
      const newLink = document.createElement('link');
      newLink.rel = 'icon';
      newLink.href = dataUrl;
      document.head.appendChild(newLink);
    } else {
      link.href = dataUrl;
    }
  };

  startChangeTabText = () => {
    let intervalFlag = false;

    let pageTitleIntervalId = setInterval(() => {
      const pageTitleStr = intervalFlag ?  "MW | DS alert!" : '***';

      intervalFlag = !intervalFlag;

      document.querySelector('title').innerHTML = pageTitleStr;
    }, 1000);

    this.setState({ pageTitleIntervalId });
  };

  stopChangeTabText = () => {
    const { pageTitleIntervalId } = this.state;

    if (pageTitleIntervalId) clearInterval(pageTitleIntervalId);
    document.querySelector('title').innerHTML = "System | Milkyweb";
  };

  render() {
    const { classes } = this.props;
    const { server_urls, public_sec_key, canPlaySound, pageTitleIntervalId } = this.state;

    return (
      <div className={classes.flex}>
        {server_urls && server_urls.length && server_urls.map((server, index) => {
          return (
            <div key={index}>
              <SystemIndicators
                serverUrl={server}
                classes={classes}
                canPlaySound={canPlaySound}
                public_sec_key={public_sec_key}
                setEmojiFavicon={this.setEmojiFavicon}
                pageTitleIntervalId={pageTitleIntervalId}
                stopChangeTabText={this.stopChangeTabText}
                startChangeTabText={this.startChangeTabText}
              />
            </div>
          )
        })}
      </div>
    )
  }
};

class SystemIndicators extends Component {
  state = {
    db: [],
    rw: [],
    rw2: [],
    reqs: {},
    conn: [],
    points: {},
    java_memory: {},
    metric_db_conn: [],
    noData: true,
    eventSource: null,
    retryTimeout: null,
  };

  componentDidMount() {
    this.setupEventSource();
  };

  componentWillUnmount() {
    this.cleanupEventSource();
  };

  componentDidUpdate = (prevProps, prevState) => {
    const { ds, node, act_node } = this.state;
    const { startChangeTabText, stopChangeTabText, setEmojiFavicon, pageTitleIntervalId } = this.props;

    if (prevState.ds === ds) return;

    if (ds || ds === 0) {
      const dsFirstNumber = ds.split('/')[0];
      const isNodeActive = node && act_node && node === act_node;

      if (dsFirstNumber && +dsFirstNumber >= 145 && isNodeActive) {
        if (pageTitleIntervalId) clearInterval(pageTitleIntervalId);

        startChangeTabText();
        setEmojiFavicon('\ud83d\udca5');
        if (this.props.canPlaySound || document.visibilityState !== 'visible') notificationSound.play();
          
      } else {
        setEmojiFavicon('\u2699\ufe0f');
        stopChangeTabText();
      }
    } else {
      setEmojiFavicon('\u2699\ufe0f');
      stopChangeTabText();
    }
  };

  setupEventSource = () => {
    const { eventSource } = this.state;
    const { serverUrl, public_sec_key } = this.props;

    if (eventSource) {
      console.info('Forcefully closing EventSource:', eventSource.url);
      eventSource.close();
      this.setState({ eventSource: null });
    }

    const newEventSource = new EventSource(`${serverUrl}/rest/get_system_indicators?token=${public_sec_key}`);

    newEventSource.onmessage = (event) => {
      const data = event.data ? JSON.parse(event.data) : null;

      if (data.java_version) {
        this.setState({
          noData: false,
          ds: data.ds,
          db: data.db,
          rw: data.rw,
          rw2: data.rw2,
          sse: data.sse,
          reqs: data.reqs,
          conn: data.conn,
          tbox: data.tbox,
          points: data.points,
          threads: data.threads,
          node: data.node || '-',
          metric_ds: data.metric_ds,
          appserver: data.appserver,
          pred_locks: data.pred_locks,
          act_node: data.act_node || '-',
          remote_addr: data.remote_addr,
          os_hardware: data.os_hardware,
          java_memory: data.java_memory,
          java_version: data.java_version,
          x_real_ip: data.x_real_ip || '-',
          metric_db_conn: data.metric_db_conn,
          app_launch_time: data.app_launch_time,
          locale_timezone: data.locale_timezone,
          incoming_msgs: data.incoming_msgs || '-',
          task_exec_duration: data.task_exec_duration,
          x_forwarded_for: data.x_forwarded_for || '-',
        });
      } else if (data) {
        this.setState({ ...data, noData: false });
      } else {
        this.handleNoData(newEventSource);
      }
    };

    newEventSource.onerror = () => {
      this.handleNoData(newEventSource);
    };

    this.setState({ eventSource });
  };

  handleNoData = (eventSource) => {
    eventSource.close();

    const retryTimeout = setTimeout(this.setupEventSource, 8000);
    this.setState({
      retryTimeout,
      noData: true,
      node: null,
    });
  };

  cleanupEventSource = () => {
    const { eventSource, retryTimeout } = this.state;

    if (eventSource) {
      console.info('Forcefully closing EventSource:', eventSource.url);
      eventSource.close();
      this.setState({ eventSource: null });
    }
    if (retryTimeout) clearTimeout(retryTimeout);

    this.setState({ eventSource: null, retryTimeout: null });
  };

  render() {
    const {
      classes,
      serverUrl,
    } = this.props;

    const {
      ds,
      db,
      rw,
      rw2,
      sse,
      reqs,
      tbox,
      node,
      conn,
      noData,
      points,
      threads,
      act_node,
      metric_ds,
      x_real_ip,
      appserver,
      pred_locks,
      remote_addr,
      os_hardware,
      java_memory,
      java_version,
      incoming_msgs,
      metric_db_conn,
      app_launch_time,
      x_forwarded_for,
      locale_timezone,
      task_exec_duration,
    } = this.state;

    const dsFirstNumber = ds && ds.split('/')[0];
    const showAlert = dsFirstNumber && +dsFirstNumber >= 140;

    const isNodeActive = node && act_node && node === act_node;

    const backgroundColor = noData ? 'red' : isNodeActive ? 'green' : '#ffb100';

    const borderLeftStyle = `3px solid ${backgroundColor}`;

    return (
      <div style={{ marginBottom: '100px' }}>
        <Table
          className={classes.tbl}
          style={{
            width: '630px',
            borderLeft: borderLeftStyle,
            backgroundColor: showAlert ? '#EDC5C3' : '#fff',
          }}
        >
          <TableBody>
            <TableRow style={{ fontWeight: 550 }}>
              <TableCell className={classes.tCellTitle} style={{ color: '#fff', backgroundColor }}>{serverUrl}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.spaceBetween}`} style={{ color: '#fff', backgroundColor }}>
                <div className={classes.mr10}>{isNodeActive ? 'Master' : noData ? 'Disconnected' : 'Slave'}</div>
              </TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>App launch time</TableCell>
              <TableCell className={classes.tCell}><div>
                {app_launch_time ? moment(app_launch_time).format('DD MMM YYYY HH:mm') : ''}
              </div></TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Java Version</TableCell>
              <TableCell className={classes.tCell}><div>{java_version}</div></TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Appserver</TableCell>
              <TableCell className={classes.tCell}>{appserver}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>OS / Hardware</TableCell>
              <TableCell className={classes.tCell}>{os_hardware}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Locale / Timezone</TableCell>
              <TableCell className={classes.tCell}>{locale_timezone}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Java Memory</TableCell>
              <TableCell
                className={classes.tCell}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <div style={{ height: '5px', width: '100px', border: '1px solid black' }}>
                  <div
                    style={{
                      height: '100%',
                      width: `${java_memory[0] + 'px'}`,
                      backgroundColor: 'greenyellow'
                    }}>
                  </div>
                </div>
                <div style={{ paddingLeft: '6px' }}>
                  {java_memory[1]} MB of {java_memory[2]} MB ({java_memory[3]}) used
                  | total = {java_memory[4]} MB
                </div>
              </TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>DS now/max num active/max (main)</TableCell>
              <TableCell className={classes.tCell}>{ds}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>DS now/max num active/max (metric)</TableCell>
              <TableCell className={classes.tCell}>{metric_ds}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>DB version/max connections/wait timeout</TableCell>
              <TableCell className={classes.tCell}>{db[0]} / {db[1]} / {db[2]}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Threads active/pool/total | Exec time min/max</TableCell>
              <TableCell className={classes.tCell}>{threads}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Incoming emails/recipients (per minute)</TableCell>
              <TableCell className={classes.tCell}>{incoming_msgs}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Total predicate locks</TableCell>
              <TableCell className={classes.tCell}>{pred_locks}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>SSE connections (system/processes)</TableCell>
              <TableCell className={classes.tCell}>{sse}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Node</TableCell>
              <TableCell className={`${classes.tCell} ${classes.bold}`}>{node}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Active node</TableCell>
              <TableCell className={`${classes.tCell} ${classes.bold}`}>{act_node}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>RemoteAddr</TableCell>
              <TableCell className={classes.tCell}>{remote_addr}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>X-FORWARDED-FOR</TableCell>
              <TableCell className={classes.tCell}>{x_forwarded_for}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>X-REAL-IP</TableCell>
              <TableCell className={classes.tCell}>{x_real_ip}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Table
          className={classes.tbl}
          style={{
            borderLeft: borderLeftStyle,
            backgroundColor: showAlert ? '#EDC5C3' : '#fff',
          }}
          >
          <TableBody>
            <TableRow>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`} colSpan={4} >Connection / RW</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}> </TableCell>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>born</TableCell>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>die</TableCell>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>diff</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle} style={{ width: '150px' }}>db conn (main)</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{conn[0]}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{conn[1]}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{conn[2]}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle} style={{ width: '150px' }}>db conn (metric)</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{metric_db_conn ? metric_db_conn[0] : 0}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{metric_db_conn ? metric_db_conn[1] : 0}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{metric_db_conn ? metric_db_conn[2] : 0}</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle} style={{ width: '150px' }}>wrappers</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{rw[0]}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{rw[1]}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{rw[2]}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Table
          className={classes.tbl}
          style={{
            borderLeft: borderLeftStyle,
            backgroundColor: showAlert ? '#EDC5C3' : '#fff',
          }}
        >
          <TableBody>
            <TableRow>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`} colSpan={4}>ThreadLocalRw</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}> </TableCell>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>born</TableCell>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>die</TableCell>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>diff</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle} style={{ width: '150px' }}>wrappers</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{rw2[0]}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{rw2[1]}</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{rw2[2]}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Table
          className={classes.tbl}
          style={{
            borderLeft: borderLeftStyle,
            backgroundColor: showAlert ? '#EDC5C3' : '#fff',
          }}
          >
          <TableBody>
            <TableRow>
              <TableCell className={classes.tCellTitle} style={{ width: '150px' }}>TBox rebuilds</TableCell>
              <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{tbox}</TableCell>
            </TableRow>
          </TableBody>
        </Table>

        <Table
          className={classes.tbl}
          style={{
            borderLeft: borderLeftStyle,
            backgroundColor: showAlert ? '#EDC5C3' : '#fff',
          }}
        >
          <TableBody>
            <TableRow>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`} colSpan={2}>Task Execution Timer</TableCell>
            </TableRow>

            <TableRow className={classes.tRow}>
              <TableCell className={classes.tCellTitle}>Name</TableCell>
              <TableCell className={`${classes.tCellTitle} ${classes.textCenter}`}>Last exec duration</TableCell>
            </TableRow>

            {task_exec_duration && Object.keys(task_exec_duration).map(taskName => {
              const duration = task_exec_duration[taskName];

              return (
                <TableRow className={classes.tRow}>
                  <TableCell className={classes.tCellTitle} style={{ width: '150px' }}>{taskName}</TableCell>
                  <TableCell className={`${classes.tCell} ${classes.textCenter}`}>{duration}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>

        <Requests
          borderLeftStyle={borderLeftStyle}
          showAlert={showAlert}
          title={'Points'}
          reqs={points}
          classes={classes}
        />

        <Requests
          borderLeftStyle={borderLeftStyle}
          showAlert={showAlert}
          title={'URLs'}
          reqs={reqs}
          classes={classes}
        />
      </div>
    );
  }
}

export default withStyles(styles)(SystemIndicatorsWrapper);
